module.exports = __webpack_public_path__ + "media/dreaker.c00cddf6.mp4";